/**
 * Tela de Backup e restauração (separada da Privacidade — uso mais rotineiro).
 */
import { ArrowLeft, HardDriveDownload } from "lucide-react";
import { BackupCard } from "./BackupCard";

export function BackupPage({ onVoltar }: { onVoltar: () => void }) {
  return (
    <div className="max-w-3xl mx-auto">
      <button
        type="button"
        onClick={onVoltar}
        className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-slate-900 mb-4"
      >
        <ArrowLeft size={16} />
        Voltar
      </button>

      <div className="flex items-center gap-2 mb-1">
        <HardDriveDownload size={22} className="text-emerald-700" />
        <h2 className="text-2xl font-semibold text-slate-900">Backup e restauração</h2>
      </div>
      <p className="text-sm text-slate-500 mb-6">
        Salve uma cópia de segurança dos seus dados (recomendado num pendrive) e
        restaure quando precisar. Faça backup com frequência.
      </p>

      <BackupCard />
    </div>
  );
}
